import newsSaga from 'AgentNewsAdministration/sagas/newsSaga';
import {all} from 'redux-saga/effects';
import newsEntrySaga from 'AgentNewsAdministration/sagas/newsEntrySaga';

export default function*() {
  yield all([newsSaga(), newsEntrySaga()]);
}
